import React from 'react';
import { Box } from '@mui/material';
import PaginationBar
  from 'Views/Page/Content/Templates/WhatIfProposalPreviewTemplate/RightSideBar/HistoryTemplate/PaginationBar';
import AccordionList from './AccordionList';

const HistoryTemplate = () => {
  return (
    <Box>
      <PaginationBar />
      <AccordionList />
    </Box>
  );
};

export default HistoryTemplate;
